import {
    mdiAccount,
    mdiAccountCheck,
    mdiAccountGroup,
    mdiAccountRemove,
    mdiAlert,
    mdiAlertCircle,
    mdiAlertCircleOutline,
    mdiAlertOutline,
    mdiArrowDown,
    mdiArrowLeft,
    mdiArrowRight,
    mdiArrowUp,
    mdiBabyFaceOutline,
    mdiCached,
    mdiCalendarMonth,
    mdiCellphoneArrowDown,
    mdiCellphoneWireless,
    mdiChartBar,
    mdiChartLine,
    mdiCheck,
    mdiCheckCircle,
    mdiCheckCircleOutline,
    mdiCheckboxBlankCircleOutline,
    mdiCheckboxBlankOutline,
    mdiCheckboxMarked,
    mdiCheckboxMarkedCircleOutline,
    mdiCheckboxMarkedOutline,
    mdiCheckboxOutline,
    mdiChevronDown,
    mdiChevronLeft,
    mdiChevronRight,
    mdiClipboard,
    mdiClipboardAlert,
    mdiClipboardCheck,
    mdiClose,
    mdiCloseCircleOutline,
    mdiClockOutline,
    mdiCloudOffOutline,
    mdiCloudSearchOutline,
    mdiCloudUpload,
    mdiCog,
    mdiCogTransfer,
    mdiContentCopy,
    mdiCrosshairsGps,
    mdiDoctor,
    mdiDownload,
    mdiEarHearing,
    mdiEarHearingOff,
    mdiEmoticonHappyOutline,
    mdiFilterOutline,
    mdiHammerScrewdriver,
    mdiHeart,
    mdiHelpCircle,
    mdiHome,
    mdiHumanPregnant,
    mdiInformation,
    mdiInformationOutline,
    mdiInformationVariant,
    mdiLightningBoltCircle,
    mdiLock,
    mdiLogout,
    mdiLungs,
    mdiMagnify,
    mdiMapMarker,
    mdiMarker,
    mdiMinus,
    mdiMortarPestlePlus,
    mdiPause,
    mdiPencil,
    mdiPlay,
    mdiPlus,
    mdiSchoolOutline,
    mdiSendVariantOutline,
    mdiStethoscope,
    mdiStopCircleOutline,
    mdiSwapVertical,
    mdiSync,
    mdiTimerSand,
    mdiTranslate,
    mdiTrashCanOutline,
    mdiUpdate,
    mdiWeb,
    mdiWhatsapp,
    mdiWifi, mdiWifiOff, mdiCircle, mdiClipboardText,
}
    from '@mdi/js'

const iconPaths = Object.freeze({
    mdiAccount: mdiAccount,
    mdiAccountCheck: mdiAccountCheck,
    mdiAccountGroup: mdiAccountGroup,
    mdiAccountRemove: mdiAccountRemove,
    mdiAlert: mdiAlert,
    mdiAlertCircle: mdiAlertCircle,
    mdiAlertCircleOutline: mdiAlertCircleOutline,
    mdiAlertOutline: mdiAlertOutline,
    mdiArrowDown: mdiArrowDown,
    mdiArrowLeft: mdiArrowLeft,
    mdiArrowRight: mdiArrowRight,
    mdiArrowUp: mdiArrowUp,
    mdiBabyFaceOutline: mdiBabyFaceOutline,
    mdiCached: mdiCached,
    mdiCalendarMonth: mdiCalendarMonth,
    mdiCellphoneArrowDown: mdiCellphoneArrowDown,
    mdiCellphoneWireless: mdiCellphoneWireless,
    mdiChartBar: mdiChartBar,
    mdiChartLine: mdiChartLine,
    mdiCheck: mdiCheck,
    mdiCheckCircle: mdiCheckCircle,
    mdiCheckCircleOutline: mdiCheckCircleOutline,
    mdiCheckboxBlankCircleOutline: mdiCheckboxBlankCircleOutline,
    mdiCheckboxBlankOutline: mdiCheckboxBlankOutline,
    mdiCheckboxMarked: mdiCheckboxMarked,
    mdiCheckboxMarkedCircleOutline: mdiCheckboxMarkedCircleOutline,
    mdiCheckboxMarkedOutline: mdiCheckboxMarkedOutline,
    mdiCheckboxOutline: mdiCheckboxOutline,
    mdiChevronDown: mdiChevronDown,
    mdiChevronLeft: mdiChevronLeft,
    mdiChevronRight: mdiChevronRight,
    mdiClipboard: mdiClipboard,
    mdiClipboardAlert: mdiClipboardAlert,
    mdiClipboardCheck: mdiClipboardCheck,
    mdiClockOutline: mdiClockOutline,
    mdiCloudOffOutline: mdiCloudOffOutline,
    mdiCloudSearchOutline: mdiCloudSearchOutline,
    mdiClose: mdiClose,
    mdiCloseCircleOutline: mdiCloseCircleOutline,
    mdiCloudUpload: mdiCloudUpload,
    mdiCog: mdiCog,
    mdiCogTransfer: mdiCogTransfer,
    mdiContentCopy: mdiContentCopy,
    mdiCrosshairsGps: mdiCrosshairsGps,
    mdiDoctor: mdiDoctor,
    mdiDownload: mdiDownload,
    mdiEarHearing: mdiEarHearing,
    mdiEarHearingOff: mdiEarHearingOff,
    mdiEmoticonHappyOutline: mdiEmoticonHappyOutline,
    mdiFilterOutline: mdiFilterOutline,
    mdiHammerScrewdriver: mdiHammerScrewdriver,
    mdiHeart: mdiHeart,
    mdiHelpCircle: mdiHelpCircle,
    mdiHome: mdiHome,
    mdiHumanPregnant: mdiHumanPregnant,
    mdiInformation: mdiInformation,
    mdiInformationOutline: mdiInformationOutline,
    mdiInformationVariant: mdiInformationVariant,
    mdiLightningBoltCircle: mdiLightningBoltCircle,
    mdiLock: mdiLock,
    mdiLogout: mdiLogout,
    mdiLungs: mdiLungs,
    mdiMagnify: mdiMagnify,
    mdiMapMarker: mdiMapMarker,
    mdiMarker: mdiMarker,
    mdiMinus: mdiMinus,
    mdiMortarPestlePlus: mdiMortarPestlePlus,
    mdiPause: mdiPause,
    mdiPencil: mdiPencil,
    mdiPlay: mdiPlay,
    mdiPlus: mdiPlus,
    mdiSchoolOutline: mdiSchoolOutline,
    mdiSendVariantOutline: mdiSendVariantOutline,
    mdiStethoscope: mdiStethoscope,
    mdiStopCircleOutline: mdiStopCircleOutline,
    mdiSwapVertical: mdiSwapVertical,
    mdiSync: mdiSync,
    mdiTimerSand: mdiTimerSand,
    mdiTranslate: mdiTranslate,
    mdiTrashCanOutline: mdiTrashCanOutline,
    mdiUpdate: mdiUpdate,
    mdiWeb: mdiWeb,
    mdiWhatsapp: mdiWhatsapp,
    mdiWifi: mdiWifi,
    mdiWifiOff: mdiWifiOff,
    mdiCircle: mdiCircle,
    mdiClipboardText: mdiClipboardText,
})

export default {
    computed: {
        icons() {
            return iconPaths
        },
        chevronBack() {
            return this.$vuetify.rtl ? iconPaths.mdiChevronRight : iconPaths.mdiChevronLeft
        },
        chevronForward() {
            return this.$vuetify.rtl ? iconPaths.mdiChevronLeft : iconPaths.mdiChevronRight
        },
    },
}
